import {getJSON, postJSON,getJSONP} from './myaxios';


export function get_user_info(ticket) {
  const params = {
    ticket: ticket,
    invoker: 'aaa',
    t: new Date().getTime()
  };
  return getJSONP(gact.config.api_user_info, params)
}


export function get_vip_info() {

  const params = {
    'version': '4.4.5.200.2.MG.0.0_Debug',
    'invoker': gact.is_ott ? 'ott' : 'mobile',
    'os': 'android',
    'ticket': $bus.ticket,
    'uuid': $bus.user.uuid,
    'mac': '111',
    't': new Date().getTime()
  }

  return getJSON(gact.config.api_vip_info, params)
}


export function get_act_stat() {
  const params = {
    act_name: window.rootdata.act_name
  }
  return getJSON(gact.config.api_act_stat, params)
}


//让ticket主动失效
export function api_logout() {
  if(window.$bus.user.ticket){
    return;
  }
  const param = {
    ticket: window.$bus.user.ticket,
    invoker: 'aaa'
  }
  return getJSONP(gact.config.api_logout, param).then(res => {
    console.log('主动退出',res)
    if(res && res.code === 200){
      console.log('主动退出成功');
    }else{
      console.error('主动退出失败')
    }
  }).catch(e=>{
    console.error('主动退出异常',e.message)
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js